import React from 'react'
import CustomerDelete from "./CustomerDelete";
import CustomerEdit from "./CustomerEdit";
import {Button} from "antd";
import {Link} from "@reach/router";

const CustomerActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <Button type={'link'}><Link to={`/landing/addresses/${record.id}`}>Adresler</Link></Button>
            <CustomerEdit  customer={record} updater={updater}/>
            <Button type={'link'}><Link to={`/landing/relevant-person/${record.id}`}>İlgililer</Link></Button>
            <CustomerDelete customer={record} updater={updater} />
        </React.Fragment>
    )
}
export default CustomerActions